import moment from 'moment';
import { API_DATE_FORMAT } from '../main/constants';

export const checkIsProjectMultiDay = ({ date, endDate }) =>
  !!endDate && moment(endDate).format(API_DATE_FORMAT) !== moment(date).format(API_DATE_FORMAT);
